import React, { useEffect, useRef } from 'react';
import MultiOptionFilter from './FilterTypes/MultiOptionFilter';
import SingleOptionFilter from './FilterTypes/SingleOptionFilter';
import RangeOptionFilter from './FilterTypes/RangeOptionFilter';
import { ISearchFilter } from '../../../../context/search/types';
import FILTER_SEARCH from '../../../../context/search/consts';

interface Props {
  index: number,
  filter: ISearchFilter,
  open: boolean,
  onToggleOpen: () => void
}

const SearchFilter: React.FC<Props> = ({ filter, index, open, onToggleOpen }): JSX.Element => {
  const filterRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Close the filter if clicked outside of it
      if (filterRef.current && !filterRef.current.contains(event.target as Node)) {
        onToggleOpen();
      }
    };

    // Attach the event listener when the filter is open
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Detach the event listener when the filter is closed
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open, onToggleOpen]);

  const renderFilterOptions = (): JSX.Element => {
    switch (filter.type) {
      case FILTER_SEARCH.FILTER_TYPES.MULTI_OPTION:
        return (<MultiOptionFilter filterIndex={index} filter={filter} />);
      case FILTER_SEARCH.FILTER_TYPES.SINGLE_OPTION:
        return (<SingleOptionFilter filterIndex={index} filter={filter} />);
      case FILTER_SEARCH.FILTER_TYPES.RANGE:
        return (<RangeOptionFilter filterIndex={index} filter={filter} />);
      default:
        return null;
    }
  }

  return (
    <div ref={filterRef} className={'sf-search-filter-container'}>
      <div onClick={() => onToggleOpen()} className={'sf-search-filter-label'}>{filter.label}</div>
      {open && renderFilterOptions()}
    </div>
  );
}

export default SearchFilter;
